import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  accordion_styles_default
} from "./chunk.2CLXCD66.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/accordion/accordion.ts
var FadvAccordion = class extends s {
  constructor() {
    super(...arguments);
    this.panelsStayOpen = false;
    this.variant = "default";
    this.panels = [];
  }
  variantChanged() {
    this.updateClasses();
  }
  getAllDetails() {
    const slot = this.accordion.querySelector("slot");
    return slot.assignedElements().filter((el) => hasTag(el, "fadv-accordion-panel"));
  }
  handleShow(event) {
    const selectedPanel = this.getPanel(event);
    if (!selectedPanel)
      return;
    if (!this.panelsStayOpen) {
      this.panels.filter((x) => x !== selectedPanel).forEach((el) => el.open = false);
    }
  }
  handleAfterShow(event) {
    const panel = this.getPanel(event);
    if (!panel)
      return;
    emit(this, "fadv-panel-show", { detail: { panelIndex: this.panels.indexOf(panel) } });
  }
  handleAfterHide(event) {
    const panel = this.getPanel(event);
    if (!panel)
      return;
    emit(this, "fadv-panel-hide", { detail: { panelIndex: this.panels.indexOf(panel) } });
  }
  getPanel(event) {
    const target = event.target;
    const panel = target.closest("fadv-accordion-panel");
    if (!panel)
      return void 0;
    return this.panels.find((el) => el === panel);
  }
  handleSlotChange() {
    this.panels = this.getAllDetails();
    this.updateClasses();
  }
  updateClasses() {
    this.panels.forEach((details, index) => {
      details.classList.add("accordion-details");
      details.classList.toggle("accordion-details--first-child", index === 0);
      details.classList.toggle("accordion-details--last-child", index === this.panels.length - 1);
      if (this.variant === "striped") {
        details.classList.toggle("accordion-details--striped-even", index % 2 === 0);
        details.classList.toggle("accordion-details--striped-odd", index % 2 !== 0);
      } else {
        details.classList.remove("accordion-details--striped-even");
        details.classList.remove("accordion-details--striped-odd");
      }
    });
  }
  render() {
    return $`<div part="base" class=${o({
      accordion: true,
      "accordion--striped": this.variant === "striped"
    })} @sl-show=${this.handleShow} @sl-after-show=${this.handleAfterShow} @sl-after-hide=${this.handleAfterHide} ><slot @slotchange=${this.handleSlotChange}></slot></div>`;
  }
};
FadvAccordion.styles = accordion_styles_default;
__decorateClass([
  e({ type: Boolean, reflect: true, attribute: "panels-stay-open" })
], FadvAccordion.prototype, "panelsStayOpen", 2);
__decorateClass([
  e({ reflect: true })
], FadvAccordion.prototype, "variant", 2);
__decorateClass([
  i(".accordion")
], FadvAccordion.prototype, "accordion", 2);
__decorateClass([
  watch("variant")
], FadvAccordion.prototype, "variantChanged", 1);
FadvAccordion = __decorateClass([
  n("fadv-accordion")
], FadvAccordion);

export {
  FadvAccordion
};
